import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";
import type { PropsWithChildren } from "react";
import { lightTheme } from "./lightTheme";
import "./material-icons.d.ts";
import "@fontsource/material-icons";

export function LightThemeProvider({ children }: PropsWithChildren) {
  return (
    <MuiThemeProvider theme={lightTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
